import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import logo from "../../media/Logo-2024.png";
import { menuItems } from "./menuItems";
import NavItem from "./NavItem";
import { useRouteColor } from "../../hooks/useRouteColors";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

function Menu() {
  const el = useRef(null);
  const { bg, nav } = useRouteColor();
  useEffect(() => {
    if (el.current) {
      // console.log(el.current.offsetHeight);
    }
  }, [el]);
  return (
    <header className="flex flex-row justify-center">
      <nav
        ref={el}
        className={`xl:w-[95vw] 2xl:w-[90vw] fixed z-[9999] transition-colors duration-500 ease-in-out bg-yellow-50 m-2 px-5 py-2 rounded-lg`}
      >
        <motion.div
          className={`flex flex-row gap-20 xl:gap-0 justify-between items-center mx-auto transition-colors duration-500 ease-in-out ${nav}`}
        >
          <Link to="/" className="flex flex-row gap-2 items-center">
            <img src={logo} width={128} height={128} alt="Brighton Centro de Inglés" className="w-16 xl:w-20" />
            {/* <h2 className="text-4xl font-bold">Brighton</h2> */}
          </Link>
          <div className=" justify-end items-center text-primario">
            <ul className="flex flex-row gap-5 items-center">
              {menuItems.map((item) => (
                <NavItem key={item.name} item={item} />
              ))}
              <li>
                <Link to={"/nosotros/contactanos"} className={"bg-yellow-1 text-primario hover:text-white font-bold px-5 py-2 rounded-lg rounded-tl-none xl:text-xl"}>Contáctanos</Link>
              </li>
            </ul>
          </div>
        </motion.div>
      </nav>
    </header>
  );
}

export default Menu;
